import React, { ReactNode } from 'react';
import { elements } from '@ecosystem/newron-design-system';
import DOMPurify from 'dompurify';

const sanitizer = DOMPurify.sanitize;

type Props = {
  children: ReactNode;
};

function ErrorPanel({ children }: Props) {
  const { Icon } = elements;
  return (
    <div className="border border-ui-red rounded flex flex-row p-4 gap-2 bg-white">
      <div>
        <Icon color="error" size="lg">
          <Icon.icons.Error />
        </Icon>
      </div>
      <div>{children}</div>
    </div>
  );
}

type TitleProps = {
  title: string;
};
function Title({ title }: TitleProps) {
  return <h3 className="text-ui-red mb-2">{title}</h3>;
}

type ResponseProps = {
  response: string;
};
function ServerResponse({ response }: ResponseProps) {
  /**
   * response might have links (<a/>) or new lines <br/>
   * this response are comming from the server and are never from user input.
   */
  return <p className="text-md text-default" dangerouslySetInnerHTML={{ __html: sanitizer(response) }} />;
}

ErrorPanel.Title = Title;
ErrorPanel.ServerResponse = ServerResponse;

export { ErrorPanel };
